/* eslint-disable no-restricted-globals, no-undef */
// Polyfill `process` global for browser deps that reference it at runtime.
// Must be imported BEFORE any other module that may touch `process`.

(function installProcessPolyfill() {
    var root;
    if (typeof globalThis !== "undefined") {
        root = globalThis;
    } else if (typeof window !== "undefined") {
        root = window;
    } else {
        root = this;
    }

    var p = root.process || {};

    if (!p.env) {
        p.env = {};
    }

    if (!p.env.NODE_ENV) {
        p.env.NODE_ENV = "development";
    }

    if (typeof p.browser === "undefined") {
        p.browser = true;
    }

    if (typeof p.nextTick !== "function") {
        p.nextTick = function nextTick(fn) {
            setTimeout(fn, 0);
        };
    }

    if (!p.versions) {
        p.versions = { node: "0.0.0" };
    }

    if (!p.platform) {
        p.platform = "browser";
    }

    if (typeof p.cwd !== "function") {
        p.cwd = function cwd() {
            return "/";
        };
    }

    root.process = p;

    if (typeof window !== "undefined") {
        window.process = p;
    }
})();
